/**
 * Chinese translations for Hashee Admin Console.
 */
export const zh: Record<string, string> = {
  // ─── Common ───
  "common.loading": "\u52A0\u8F7D\u4E2D...",
  "common.search": "\u641C\u7D22",
  "common.apply": "\u5E94\u7528",
  "common.filter": "\u7B5B\u9009",
  "common.refresh": "\u5237\u65B0",
  "common.cancel": "\u53D6\u6D88",
  "common.confirm": "\u786E\u8BA4",
  "common.prev": "\u4E0A\u4E00\u9875",
  "common.next": "\u4E0B\u4E00\u9875",
  "common.previous": "\u4E0A\u4E00\u9875",
  "common.view": "\u67E5\u770B",
  "common.yes": "\u662F",
  "common.no": "\u5426",
  "common.date": "\u65E5\u671F",
  "common.status": "\u72B6\u6001",
  "common.created": "\u521B\u5EFA\u65F6\u95F4",
  "common.action": "\u64CD\u4F5C",
  "common.from": "\u4ECE",
  "common.to": "\u5230",
  "common.failed_to_load": "\u52A0\u8F7D\u5931\u8D25",
  "common.action_failed": "\u64CD\u4F5C\u5931\u8D25",
  "common.no_data_for_period": "\u8BE5\u65F6\u6BB5\u65E0\u6570\u636E",
  "common.show_details": "\u663E\u793A\u660E\u7EC6",
  "common.hide_details": "\u9690\u85CF\u660E\u7EC6",
  "common.all": "\u5168\u90E8",
  "stats.total": "\u603B\u8BA1",

  // ─── Sidebar ───
  "sidebar.logo": "Hashee \u8FD0\u7EF4",
  "sidebar.sign_out": "\u9000\u51FA\u767B\u5F55",
  "nav.dashboard": "\u4EEA\u8868\u76D8",
  "nav.metrics": "\u6307\u6807",
  "nav.integrations": "\u96C6\u6210",
  "nav.users": "\u7528\u6237",
  "nav.users.all": "\u6240\u6709\u7528\u6237",
  "nav.content": "\u5185\u5BB9",
  "nav.content.storage": "\u5B58\u50A8",
  "nav.content.summary_jobs": "\u6458\u8981\u4EFB\u52A1",
  "nav.content.conversations": "\u4F1A\u8BDD",
  "nav.content.deliveries": "\u4EA4\u4ED8\u7269",
  "nav.revenue": "\u8425\u6536",
  "nav.revenue.billing": "\u8D26\u5355",
  "nav.governance": "\u6CBB\u7406",
  "nav.governance.relations": "\u5173\u7CFB",
  "nav.governance.blocks": "\u5C4F\u853D",
  "nav.governance.agents": "Agent",
  "nav.governance.grants": "\u6388\u6743",
  "nav.governance.audit_log": "\u5BA1\u8BA1\u65E5\u5FD7",
  "nav.system": "\u7CFB\u7EDF",
  "nav.system.health": "\u5065\u5EB7\u72B6\u6001",
  "nav.system.crashes": "\u5D29\u6E83\u62A5\u544A",

  // ─── Login ───
  "login.title": "Hashee \u8FD0\u7EF4\u63A7\u5236\u53F0",
  "login.subtitle": "\u4F7F\u7528\u7BA1\u7406\u5458\u8D26\u53F7\u767B\u5F55",
  "login.email": "\u90AE\u7BB1",
  "login.password": "\u5BC6\u7801",
  "login.signing_in": "\u767B\u5F55\u4E2D...",
  "login.sign_in": "\u767B\u5F55",
  "login.dismiss_error": "\u5173\u95ED\u9519\u8BEF",

  // ─── Dashboard ───
  "dashboard.title": "\u4EEA\u8868\u76D8",
  "dashboard.description":
    "\u7CFB\u7EDF\u6982\u89C8\u4E0E\u5173\u952E\u6307\u6807",
  "dashboard.humans": "\u7528\u6237\u6570",
  "dashboard.paid_users": "\u4ED8\u8D39\u7528\u6237",
  "dashboard.summary_failed_24h": "\u6458\u8981\u5931\u8D25 (24h)",
  "dashboard.system_status": "\u7CFB\u7EDF\u72B6\u6001",
  "dashboard.status_healthy": "\u5065\u5EB7",
  "dashboard.status_degraded": "\u964D\u7EA7",
  "dashboard.status_down": "\u5B95\u673A",
  "dashboard.of_total": "\u5360\u603B\u6570",
  "dashboard.alerts": "\u544A\u8B66",
  "dashboard.no_active_alerts": "\u65E0\u6D3B\u52A8\u544A\u8B66",
  "dashboard.failed_summary_jobs":
    "\u4E2A\u6458\u8981\u4EFB\u52A1\u5728\u8FC7\u53BB 24 \u5C0F\u65F6\u5185\u5931\u8D25",
  "dashboard.view_summary_jobs": "\u67E5\u770B\u6458\u8981\u4EFB\u52A1",
  "dashboard.is_status": "\u72B6\u6001\u4E3A",
  "dashboard.cron_prefix": "\u5B9A\u65F6\u4EFB\u52A1",
  "dashboard.poison_messages":
    "\u4E2A\u6BD2\u6D88\u606F\u5728\u961F\u5217\u4E2D",
  "dashboard.view_system_health": "\u67E5\u770B\u7CFB\u7EDF\u5065\u5EB7",
  "dashboard.messages_today": "\u4ECA\u65E5\u6D88\u606F",
  "dashboard.relations": "\u5173\u7CFB",
  "dashboard.conversations": "\u4F1A\u8BDD",
  "dashboard.message_distribution": "\u6D88\u606F\u5206\u5E03 (30\u5929)",
  "dashboard.human_messages": "\u4EBA\u7C7B",
  "dashboard.agent_messages": "Agent",
  "dashboard.system_messages": "\u7CFB\u7EDF",
  "dashboard.vs_last_week": "上周同期：{{value}}",

  // ─── Status Bar ───
  "dashboard.status_alerts": "{{count}} 条告警",
  "dashboard.status_anomalous": "{{count}} 个 KPI 异常",
  "dashboard.status_normal": "{{count}} 个 KPI 正常",
  "dashboard.status_all_healthy": "全部正常",

  // ─── Dashboard Alerts ───
  "dashboard.all_systems_healthy": "所有系统健康",
  "dashboard.runbook_prefix": "操作建议:",

  // ─── Dashboard KPI Labels ───
  "dashboard.kpi_new_users": "新增用户",
  "dashboard.kpi_new_agents": "新增 Agent",
  "dashboard.kpi_dau": "日活",
  "dashboard.kpi_mrr": "月收入",
  "dashboard.group_label_short": "群组",

  // ─── Dashboard Social Trends ───
  "dashboard.social_trends_title": "社交趋势 (30天)",
  "dashboard.dim_by_type": "按类型",
  "dashboard.dim_by_agent": "按 Agent",
  "dashboard.dim_by_country": "按国家",
  "dashboard.h2a_label": "H2A 消息",
  "dashboard.h2h_label": "H2H 消息",
  "dashboard.group_label": "群组消息",
  "dashboard.funnel_title": "核心漏斗",

  // ─── Funnel Mini ───
  "funnel.step_register": "注册",
  "funnel.step_conversation": "对话",
  "funnel.step_summary": "摘要",
  "funnel.step_delivery": "推送",
  "funnel.step_share": "分享",
  "funnel.step_storage": "存储",
  "funnel.step_payment": "付款",
  "funnel.conversion_rate": "\u2193 {{percent}}%",
  "funnel.empty_hint":
    "\u6F0F\u6597\u6570\u636E\u7531\u6BCF\u65E5\u5B9A\u65F6\u4EFB\u52A1\u8BA1\u7B97\u3002\u5982\u4E3A\u7A7A\uFF0C\u8BF7\u68C0\u67E5\u7CFB\u7EDF > \u5065\u5EB7\u72B6\u6001\u4E2D\u7684\u5B9A\u65F6\u4EFB\u52A1\u3002",

  // ─── Trend Card ───
  "trend.up": "\u2191",
  "trend.down": "\u2193",
  "trend.flat": "\u2014",

  // ─── Growth Trend Chart ───
  "growth_trend.title": "\u589E\u957F\u8D8B\u52BF (30 \u5929)",
  "growth_trend.chart_label":
    "\u589E\u957F\u8D8B\u52BF\u56FE\uFF0C\u663E\u793A DAU \u548C\u65B0\u7528\u6237",
  "growth_trend.chart_title": "\u589E\u957F\u8D8B\u52BF",
  "growth_trend.dau": "DAU",
  "growth_trend.new_users": "\u65B0\u7528\u6237",

  // ─── Suggestions ───
  "suggestions.title": "\u5EFA\u8BAE",
  "suggestions.loading": "\u52A0\u8F7D\u5EFA\u8BAE\u4E2D...",
  "suggestions.ops": "\u8FD0\u7EF4\u5EFA\u8BAE",
  "suggestions.product": "\u4EA7\u54C1\u5EFA\u8BAE",
  "suggestions.no_suggestions": "\u6682\u65E0\u5EFA\u8BAE",

  // ─── Confirm Dialog ───
  "confirm.reason_label":
    "\u539F\u56E0\uFF08\u6700\u5C11 {{min}} \u4E2A\u5B57\u7B26\uFF09",
  "confirm.reason_placeholder":
    "\u8BF7\u8BF4\u660E\u6B64\u64CD\u4F5C\u7684\u5FC5\u8981\u6027...",
  "confirm.chars_remaining_one": "\u8FD8\u9700 {{count}} \u4E2A\u5B57\u7B26",
  "confirm.chars_remaining_other": "\u8FD8\u9700 {{count}} \u4E2A\u5B57\u7B26",

  // ─── Pagination (DataTable) ───
  "pagination.prev": "\u4E0A\u4E00\u9875",
  "pagination.next": "\u4E0B\u4E00\u9875",

  // ─── Table (TableParts) ───
  "table.loading": "\u52A0\u8F7D\u4E2D...",

  // ─── Global Filters ───
  "filters.platform": "\u5E73\u53F0",
  "filters.country": "\u56FD\u5BB6",
  "filters.language": "\u8BED\u8A00",
  "filters.all_platforms": "\u6240\u6709\u5E73\u53F0",
  "filters.all_countries": "\u6240\u6709\u56FD\u5BB6",
  "filters.all_languages": "\u6240\u6709\u8BED\u8A00",

  // ─── Not Found ───
  "not_found.title": "404",
  "not_found.text": "\u9875\u9762\u672A\u627E\u5230",
  "not_found.back": "\u8FD4\u56DE\u4EEA\u8868\u76D8",

  // ─── Placeholder ───
  "placeholder.management": "\u7BA1\u7406",
  "placeholder.wave2":
    "\u6B64\u9875\u9762\u5C06\u5728\u7B2C\u4E8C\u6CE2\u5B9E\u73B0\u3002",

  // ─── Users ───
  "users.title": "\u7528\u6237",
  "users.description": "\u7BA1\u7406\u7528\u6237\u8D26\u53F7",
  "users.search_placeholder":
    "\u6309\u540D\u79F0\u3001\u90AE\u7BB1\u6216 ID \u641C\u7D22...",
  "users.all_status": "\u6240\u6709\u72B6\u6001",
  "users.all_plans": "\u6240\u6709\u65B9\u6848",
  "users.no_users_found": "\u672A\u627E\u5230\u7528\u6237\u3002",
  "users.loading": "\u52A0\u8F7D\u4E2D...",
  "users.col_name": "\u540D\u79F0",
  "users.col_email": "\u90AE\u7BB1",
  "users.col_custom_id": "\u81EA\u5B9A\u4E49 ID",
  "users.col_plan": "\u65B9\u6848",
  "users.col_tokens": "Token",
  "users.col_storage": "\u5B58\u50A8",
  "users.col_status": "\u72B6\u6001",
  "users.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "users.page_info":
    "{{total}} \u4E2A\u7528\u6237 \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── User Detail ───
  "user_detail.loading": "\u52A0\u8F7D\u4E2D...",
  "user_detail.not_found": "\u672A\u627E\u5230\u7528\u6237\u3002",
  "user_detail.failed_to_load": "\u52A0\u8F7D\u7528\u6237\u5931\u8D25",
  "user_detail.deactivated": "\u5DF2\u505C\u7528",
  "user_detail.freeze_account": "\u51BB\u7ED3\u8D26\u53F7",
  "user_detail.unfreeze_account": "\u89E3\u51BB\u8D26\u53F7",
  "user_detail.freeze_title": "\u51BB\u7ED3\u8D26\u53F7",
  "user_detail.unfreeze_title": "\u89E3\u51BB\u8D26\u53F7",
  "user_detail.freeze_desc":
    "\u8FD9\u5C06\u7ACB\u5373\u64A4\u9500\u6240\u6709\u4F1A\u8BDD\u5E76\u65AD\u5F00\u7528\u6237\u8FDE\u63A5\u3002",
  "user_detail.unfreeze_desc":
    "\u8FD9\u5C06\u6062\u590D\u7528\u6237\u7684\u8BBF\u95EE\u6743\u9650\u3002\u7528\u6237\u9700\u8981\u91CD\u65B0\u767B\u5F55\u3002",
  "user_detail.user_id": "\u7528\u6237 ID",
  "user_detail.custom_id": "\u81EA\u5B9A\u4E49 ID",
  "user_detail.status": "\u72B6\u6001",
  "user_detail.created": "\u521B\u5EFA\u65F6\u95F4",
  "user_detail.tab_overview": "\u6982\u89C8",
  "user_detail.tab_summary_jobs": "\u6458\u8981\u4EFB\u52A1",
  "user_detail.tab_audit": "\u5BA1\u8BA1",
  "user_detail.tab_billing": "\u8D26\u5355",
  "user_detail.plan": "\u65B9\u6848",
  "user_detail.token_balance": "Token \u4F59\u989D",
  "user_detail.storage": "\u5B58\u50A8",
  "user_detail.devices": "\u8BBE\u5907",
  "user_detail.no_summary_jobs": "\u65E0\u6458\u8981\u4EFB\u52A1\u3002",
  "user_detail.no_audit_records": "\u65E0\u5BA1\u8BA1\u8BB0\u5F55\u3002",
  "user_detail.no_billing_events": "\u65E0\u8D26\u5355\u4E8B\u4EF6\u3002",
  "user_detail.col_status": "\u72B6\u6001",
  "user_detail.col_target": "\u76EE\u6807",
  "user_detail.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "user_detail.col_action": "\u64CD\u4F5C",
  "user_detail.col_type": "\u7C7B\u578B",
  "user_detail.col_amount": "\u91D1\u989D",

  // ─── Agents ───
  "agents.title": "Agent",
  "agents.description": "Agent \u6CBB\u7406\u7BA1\u7406",
  "agents.search_placeholder":
    "\u6309\u540D\u79F0\u6216\u521B\u5EFA\u8005\u641C\u7D22...",
  "agents.all_status": "\u6240\u6709\u72B6\u6001",
  "agents.no_agents_found": "\u672A\u627E\u5230 Agent\u3002",
  "agents.loading": "\u52A0\u8F7D\u4E2D...",
  "agents.col_name": "\u540D\u79F0",
  "agents.col_creator": "\u521B\u5EFA\u8005",
  "agents.col_connection": "\u8FDE\u63A5",
  "agents.col_status": "\u72B6\u6001",
  "agents.col_risk": "\u98CE\u9669",
  "agents.col_reports": "\u4E3E\u62A5",
  "agents.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "agents.failed_to_load": "\u52A0\u8F7D Agent \u5931\u8D25",

  // ─── Agent Detail ───
  "agent_detail.created_by": "\u521B\u5EFA\u8005: {{name}}",
  "agent_detail.loading": "\u52A0\u8F7D\u4E2D...",
  "agent_detail.not_found": "\u672A\u627E\u5230 Agent\u3002",
  "agent_detail.failed_to_load": "\u52A0\u8F7D Agent \u5931\u8D25",
  "agent_detail.banned": "\u5DF2\u5C01\u7981",
  "agent_detail.restrict_agent": "\u9650\u5236 Agent",
  "agent_detail.restore_agent": "\u6062\u590D Agent",
  "agent_detail.restrict_title": "\u9650\u5236 Agent",
  "agent_detail.restore_title": "\u6062\u590D Agent",
  "agent_detail.restrict_desc":
    "\u8FD9\u5C06\u9650\u5236 Agent \u8FD0\u884C\u3002\u73B0\u6709\u8FDE\u63A5\u5C06\u53D7\u5F71\u54CD\u3002",
  "agent_detail.restore_desc":
    "\u8FD9\u5C06\u6062\u590D Agent \u4E3A\u6D3B\u52A8\u72B6\u6001\u3002",
  "agent_detail.agent_id": "Agent ID",
  "agent_detail.status": "\u72B6\u6001",
  "agent_detail.connection": "\u8FDE\u63A5",
  "agent_detail.risk_score": "\u98CE\u9669\u5206",
  "agent_detail.reports": "\u4E3E\u62A5",
  "agent_detail.description": "\u63CF\u8FF0",
  "agent_detail.created": "\u521B\u5EFA\u65F6\u95F4",
  "agent_detail.h2a_active": "\u6D3B\u52A8",
  "agent_detail.h2a_suspended": "\u5DF2\u6682\u505C",
  "agent_detail.h2a_terminated": "\u5DF2\u7EC8\u6B62",
  "agent_detail.tab_overview": "\u6982\u89C8",
  "agent_detail.tab_governance_history": "\u6CBB\u7406\u5386\u53F2",
  "agent_detail.tab_reports": "\u4E3E\u62A5",
  "agent_detail.connection_mode": "\u8FDE\u63A5\u6A21\u5F0F",
  "agent_detail.report_count": "\u4E3E\u62A5\u6570",
  "agent_detail.last_updated": "\u6700\u540E\u66F4\u65B0",
  "agent_detail.no_governance_history": "\u65E0\u6CBB\u7406\u5386\u53F2\u3002",
  "agent_detail.no_reports": "\u65E0\u4E3E\u62A5\u3002",
  "agent_detail.col_reporter": "\u4E3E\u62A5\u4EBA",
  "agent_detail.col_reason": "\u539F\u56E0",
  "agent_detail.col_status": "\u72B6\u6001",
  "agent_detail.col_date": "\u65E5\u671F",

  // ─── Grants ───
  "grants.title": "Token \u6388\u6743",
  "grants.description": "\u6570\u636E\u8BBF\u95EE\u6388\u6743",
  "grants.placeholder_user_id": "\u7528\u6237 ID",
  "grants.placeholder_agent_id": "Agent ID",
  "grants.placeholder_scope_type": "\u8303\u56F4\u7C7B\u578B",
  "grants.placeholder_status": "\u72B6\u6001",
  "grants.no_grants_found": "\u672A\u627E\u5230\u6388\u6743",
  "grants.col_grant_id": "\u6388\u6743 ID",
  "grants.col_user": "\u7528\u6237",
  "grants.col_agent": "Agent",
  "grants.col_scope": "\u8303\u56F4",
  "grants.col_expires": "\u8FC7\u671F",
  "grants.col_status": "\u72B6\u6001",
  "grants.never": "\u6C38\u4E0D",
  "grants.loading_detail": "\u52A0\u8F7D\u8BE6\u60C5...",
  "grants.scope_value": "\u8303\u56F4\u503C:",
  "grants.created": "\u521B\u5EFA\u65F6\u95F4:",
  "grants.summary_jobs": "\u6458\u8981\u4EFB\u52A1",
  "grants.no_summary_jobs": "\u65E0\u5173\u8054\u6458\u8981\u4EFB\u52A1",

  // ─── Audit ───
  "audit.title": "\u5BA1\u8BA1\u65E5\u5FD7",
  "audit.description": "\u7BA1\u7406\u64CD\u4F5C\u5386\u53F2",
  "audit.placeholder_action": "\u64CD\u4F5C",
  "audit.placeholder_actor_id": "\u64CD\u4F5C\u4EBA ID",
  "audit.placeholder_target_id": "\u76EE\u6807 ID",
  "audit.start_date": "\u5F00\u59CB\u65E5\u671F",
  "audit.end_date": "\u7ED3\u675F\u65E5\u671F",
  "audit.col_action": "\u64CD\u4F5C",
  "audit.col_actor": "\u64CD\u4F5C\u4EBA",
  "audit.col_target": "\u76EE\u6807",
  "audit.col_metadata": "\u5143\u6570\u636E",
  "audit.col_date": "\u65E5\u671F",
  "audit.no_records_found": "\u672A\u627E\u5230\u5BA1\u8BA1\u8BB0\u5F55",

  // ─── Metrics Layout ───
  "metrics.title": "\u6307\u6807",
  "metrics.description": "\u5206\u6790\u4E0E\u6027\u80FD\u6570\u636E",
  "metrics.tab_growth": "\u589E\u957F",
  "metrics.tab_funnel": "\u6F0F\u6597",
  "metrics.tab_revenue": "\u8425\u6536",
  "metrics.tab_system": "\u7CFB\u7EDF",
  "metrics.tab_behavior": "\u884C\u4E3A",
  "metrics.tab_messages": "\u6D88\u606F",
  "metrics.tab_feature_value": "\u529F\u80FD\u4EF7\u503C",
  "metrics.tab_segments": "\u5206\u7FA4",
  "metrics.tab_cohort": "\u7FA4\u7EC4",

  // ─── Growth Tab ───
  "growth.avg_dau": "\u5E73\u5747 DAU",
  "growth.new_users": "\u65B0\u7528\u6237",
  "growth.messages": "\u6D88\u606F",
  "growth.summary_requests": "\u6458\u8981\u8BF7\u6C42",
  "growth.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "growth.col_date": "\u65E5\u671F",
  "growth.col_dau": "DAU",
  "growth.col_new_users": "\u65B0\u7528\u6237",
  "growth.col_messages": "\u6D88\u606F",
  "growth.col_summary_req": "\u6458\u8981\u8BF7\u6C42",

  // ─── Funnel Tab ───
  "funnel.funnel_steps": "\u6F0F\u6597\u6B65\u9AA4",
  "funnel.no_funnel_data": "\u65E0\u6F0F\u6597\u6570\u636E",
  "funnel.label_funnel": "\u6F0F\u6597",
  "funnel.activation": "\u6FC0\u6D3B",
  "funnel.content_loop": "\u5185\u5BB9\u5FAA\u73AF",
  "funnel.monetization": "\u53D8\u73B0",

  // ─── Revenue Tab ───
  "revenue.mrr": "MRR",
  "revenue.paid_users": "\u4ED8\u8D39\u7528\u6237",
  "revenue.checkouts": "\u7ED3\u8D26",
  "revenue.topups": "\u5145\u503C",
  "revenue.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "revenue.col_date": "\u65E5\u671F",
  "revenue.col_mrr": "MRR",
  "revenue.col_paid_users": "\u4ED8\u8D39\u7528\u6237",
  "revenue.col_checkouts": "\u7ED3\u8D26",
  "revenue.col_topups": "\u5145\u503C",

  // ─── System Tab ───
  "system_tab.summary_requests": "\u6458\u8981\u8BF7\u6C42",
  "system_tab.success_rate": "\u6210\u529F\u7387",
  "system_tab.storage": "\u5B58\u50A8",
  "system_tab.webhook_failures": "Webhook \u5931\u8D25",
  "system_tab.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "system_tab.col_date": "\u65E5\u671F",
  "system_tab.col_summary_req": "\u6458\u8981\u8BF7\u6C42",
  "system_tab.col_success": "\u6210\u529F",
  "system_tab.col_failed": "\u5931\u8D25",
  "system_tab.col_storage": "\u5B58\u50A8",
  "system_tab.col_wh_failures": "WH \u5931\u8D25",

  // ─── Behavior Tab ───
  "behavior.sessions_per_user": "\u4F1A\u8BDD / \u7528\u6237 / \u5929",
  "behavior.messages_per_user": "\u6D88\u606F / \u7528\u6237 / \u5929",
  "behavior.summaries_per_user": "\u6458\u8981 / \u7528\u6237 / \u5929",
  "behavior.bookmarks_per_user": "\u4E66\u7B7E / \u7528\u6237 / \u5929",
  "behavior.shares_per_user": "\u5206\u4EAB / \u7528\u6237 / \u5929",
  "behavior.agent_usage_rate": "Agent \u4F7F\u7528\u7387",
  "behavior.retention_rate": "\u7559\u5B58\u7387",
  "behavior.message_breakdown": "\u6D88\u606F\u5206\u5E03",
  "behavior.human_messages": "\u4EBA\u7C7B\u6D88\u606F",
  "behavior.agent_messages": "Agent \u6D88\u606F",
  "behavior.group_messages": "\u7FA4\u7EC4\u6D88\u606F",
  "behavior.daily_breakdown": "\u6BCF\u65E5\u660E\u7EC6",
  "behavior.col_date": "\u65E5\u671F",
  "behavior.col_sessions": "\u4F1A\u8BDD/U",
  "behavior.col_msgs": "\u6D88\u606F/U",
  "behavior.col_summaries": "\u6458\u8981/U",
  "behavior.col_bookmarks": "\u4E66\u7B7E/U",
  "behavior.col_shares": "\u5206\u4EAB/U",
  "behavior.col_agent_rate": "Agent \u7387",
  "behavior.col_retention": "\u7559\u5B58",

  // ─── Feature Value Tab ───
  "feature_value.title": "\u529F\u80FD\u4EF7\u503C\u5206\u6790",
  "feature_value.col_feature": "\u529F\u80FD",
  "feature_value.col_exposure": "\u66DD\u5149",
  "feature_value.col_adoption": "\u91C7\u7528",
  "feature_value.col_repeat": "\u91CD\u590D",
  "feature_value.col_retention_lift": "\u7559\u5B58\u63D0\u5347",
  "feature_value.col_status": "\u72B6\u6001",
  "feature_value.core_feature": "\u6838\u5FC3\u529F\u80FD",
  "feature_value.exposed_but_weak": "\u66DD\u5149\u4F46\u5F31",
  "feature_value.used_but_shallow": "\u4F7F\u7528\u4F46\u6D45",
  "feature_value.neutral": "\u4E2D\u6027",

  // ─── Segment Tab ───
  "segment.distribution": "\u5206\u7FA4\u5206\u5E03",
  "segment.no_data": "\u8BE5\u65E5\u671F\u65E0\u5206\u7FA4\u6570\u636E",
  "segment.users_title": "\u7528\u6237",
  "segment.power_user": "\u8D85\u7EA7\u7528\u6237",
  "segment.builder": "\u521B\u5EFA\u8005",
  "segment.organizer": "\u7EC4\u7EC7\u8005",
  "segment.reader": "\u9605\u8BFB\u8005",
  "segment.chat_only": "\u4EC5\u804A\u5929",
  "segment.col_user_id": "\u7528\u6237 ID",
  "segment.col_messages": "\u6D88\u606F",
  "segment.col_summaries": "\u6458\u8981",
  "segment.col_deliveries": "\u4EA4\u4ED8\u7269",
  "segment.col_shares": "\u5206\u4EAB",
  "segment.col_favorited": "\u6536\u85CF",
  "segment.no_users": "\u8BE5\u5206\u7FA4\u65E0\u7528\u6237",

  // ─── Cohort Tab ───
  "cohort.cohorts": "\u7FA4\u7EC4",
  "cohort.total_users": "\u603B\u7528\u6237",
  "cohort.avg_week1_retention": "\u7B2C1\u5468\u5E73\u5747\u7559\u5B58",
  "cohort.avg_week4_retention": "\u7B2C4\u5468\u5E73\u5747\u7559\u5B58",
  "cohort.retention_matrix": "\u7559\u5B58\u77E9\u9635",
  "cohort.col_cohort_week": "\u7FA4\u7EC4\u5468",
  "cohort.col_users": "\u7528\u6237",
  "cohort.no_cohort_data": "\u65E0\u7FA4\u7EC4\u6570\u636E",

  // ─── Billing Page ───
  "billing.title": "\u8D26\u5355",
  "billing.description":
    "\u7528\u6237\u8D26\u5355\u67E5\u8BE2\u4E0E\u64CD\u4F5C",
  "billing.search_placeholder": "\u8F93\u5165 user_id...",
  "billing.user": "\u7528\u6237",
  "billing.plan": "\u65B9\u6848",
  "billing.status": "\u72B6\u6001",
  "billing.token_balance": "Token \u4F59\u989D",
  "billing.grant_tokens": "\u53D1\u653E Token",
  "billing.resync_entitlement": "\u91CD\u65B0\u540C\u6B65\u6743\u76CA",
  "billing.token_amount_label": "\u53D1\u653E Token \u6570\u91CF:",
  "billing.grant_title": "\u53D1\u653E Token",
  "billing.resync_title": "\u91CD\u65B0\u540C\u6B65\u6743\u76CA",
  "billing.replay_title": "\u91CD\u64AD Webhook",
  "billing.grant_desc":
    "\u5411\u6B64\u7528\u6237\u53D1\u653E {{amount}} \u4E2A Token\u3002",
  "billing.resync_desc":
    "\u4ECE Stripe \u91CD\u65B0\u540C\u6B65\u6743\u76CA\u3002",
  "billing.replay_desc":
    "\u91CD\u64AD\u6B64\u5931\u8D25\u7684 Webhook \u4E8B\u4EF6\u3002",

  // ─── Billing Tables ───
  "billing_table.token_ledger": "Token \u8D26\u672C",
  "billing_table.col_type": "\u7C7B\u578B",
  "billing_table.col_amount": "\u91D1\u989D",
  "billing_table.col_balance_after": "\u64CD\u4F5C\u540E\u4F59\u989D",
  "billing_table.col_reason": "\u539F\u56E0",
  "billing_table.col_date": "\u65E5\u671F",
  "billing_table.no_ledger_entries": "\u65E0\u8D26\u672C\u8BB0\u5F55",
  "billing_table.webhook_events": "Webhook \u4E8B\u4EF6",
  "billing_table.col_provider": "\u63D0\u4F9B\u5546",
  "billing_table.col_event_type": "\u4E8B\u4EF6\u7C7B\u578B",
  "billing_table.col_status": "\u72B6\u6001",
  "billing_table.col_action": "\u64CD\u4F5C",
  "billing_table.replay": "\u91CD\u64AD",
  "billing_table.no_webhook_events": "\u65E0 Webhook \u4E8B\u4EF6",

  // ─── Storage Page ───
  "storage.title": "\u5B58\u50A8",
  "storage.description":
    "\u76D1\u63A7\u7528\u6237\u5B58\u50A8\u4F7F\u7528\u4E0E\u540C\u6B65\u72B6\u6001",
  "storage.filter_all": "\u5168\u90E8",
  "storage.filter_over_quota": "\u8D85\u51FA\u914D\u989D",
  "storage.filter_sync_error": "\u540C\u6B65\u9519\u8BEF",
  "storage.no_users_found": "\u672A\u627E\u5230\u7528\u6237\u3002",
  "storage.col_user": "\u7528\u6237",
  "storage.col_used_limit": "\u5DF2\u7528 / \u9650\u989D",
  "storage.col_msg": "\u6D88\u606F",
  "storage.col_media": "\u5A92\u4F53",
  "storage.col_art": "\u4F5C\u54C1",
  "storage.col_kb": "\u77E5\u8BC6\u5E93",
  "storage.col_sync": "\u540C\u6B65",

  // ─── Storage Detail Panel ───
  "storage_detail.breakdown": "\u660E\u7EC6",
  "storage_detail.failed_to_load": "\u52A0\u8F7D\u8BE6\u60C5\u5931\u8D25\u3002",
  "storage_detail.recalculate": "\u91CD\u65B0\u8BA1\u7B97",
  "storage_detail.run_cleanup": "\u8FD0\u884C\u6E05\u7406",
  "storage_detail.recalculate_title": "\u91CD\u65B0\u8BA1\u7B97\u5B58\u50A8",
  "storage_detail.recalculate_desc":
    "\u8FD9\u5C06\u6839\u636E\u5BF9\u8C61\u5927\u5C0F\u91CD\u65B0\u8BA1\u7B97\u603B\u5B58\u50A8\u4F7F\u7528\u91CF\u3002\u73B0\u6709\u503C\u5C06\u88AB\u8986\u76D6\u3002",
  "storage_detail.cleanup_title": "\u8FD0\u884C\u6E05\u7406",
  "storage_detail.cleanup_desc":
    "\u8FD9\u5C06\u6807\u8BB0\u6240\u6709\u8F6F\u5220\u9664\u5BF9\u8C61\u4E3A\u7269\u7406\u5220\u9664\u3002\u6B64\u64CD\u4F5C\u4E0D\u53EF\u64A4\u9500\u3002",

  // ─── Summary Jobs Page ───
  "summary_jobs.title": "\u6458\u8981\u4EFB\u52A1",
  "summary_jobs.description":
    "\u76D1\u63A7 AI \u6458\u8981\u4EFB\u52A1\u5E76\u91CD\u8BD5\u5931\u8D25",
  "summary_jobs.filter_all": "\u5168\u90E8",
  "summary_jobs.filter_pending": "\u7B49\u5F85\u4E2D",
  "summary_jobs.filter_running": "\u8FD0\u884C\u4E2D",
  "summary_jobs.filter_completed": "\u5DF2\u5B8C\u6210",
  "summary_jobs.filter_failed": "\u5931\u8D25",
  "summary_jobs.user_id_placeholder": "\u6309\u7528\u6237 ID \u7B5B\u9009...",
  "summary_jobs.no_jobs_found": "\u672A\u627E\u5230\u4EFB\u52A1\u3002",
  "summary_jobs.col_target": "\u76EE\u6807",
  "summary_jobs.col_user": "\u7528\u6237",
  "summary_jobs.col_status": "\u72B6\u6001",
  "summary_jobs.col_model": "\u6A21\u578B",
  "summary_jobs.col_tokens_in": "Tokens \u8F93\u5165",
  "summary_jobs.col_tokens_out": "Tokens \u8F93\u51FA",
  "summary_jobs.col_created": "\u521B\u5EFA\u65F6\u95F4",

  // ─── Summary Job Detail Panel ───
  "summary_job_detail.failed_to_load":
    "\u52A0\u8F7D\u8BE6\u60C5\u5931\u8D25\u3002",
  "summary_job_detail.error": "\u9519\u8BEF",
  "summary_job_detail.grant": "\u6388\u6743",
  "summary_job_detail.scope": "\u8303\u56F4",
  "summary_job_detail.expires": "\u8FC7\u671F",
  "summary_job_detail.thread": "\u7EBF\u7A0B",
  "summary_job_detail.thread_status": "\u72B6\u6001",
  "summary_job_detail.preview": "\u9884\u89C8",
  "summary_job_detail.retry_job": "\u91CD\u8BD5\u4EFB\u52A1",
  "summary_job_detail.retry_title": "\u91CD\u8BD5\u6458\u8981\u4EFB\u52A1",
  "summary_job_detail.retry_desc":
    "\u8FD9\u5C06\u4F7F\u7528\u76F8\u540C\u76EE\u6807\u521B\u5EFA\u65B0\u7684\u7B49\u5F85\u4EFB\u52A1\u3002\u5931\u8D25\u7684\u4EFB\u52A1\u8BB0\u5F55\u5C06\u4FDD\u7559\u4EE5\u4F9B\u5BA1\u8BA1\u3002",

  // ─── Deliveries Page ───
  "deliveries.title": "\u4EA4\u4ED8\u7269",
  "deliveries.description": "\u7BA1\u7406\u4EA4\u4ED8\u5185\u5BB9",
  "deliveries.all_types": "\u6240\u6709\u7C7B\u578B",
  "deliveries.user_id_placeholder": "\u6309\u7528\u6237 ID \u7B5B\u9009...",
  "deliveries.no_deliveries_found":
    "\u672A\u627E\u5230\u4EA4\u4ED8\u7269\u3002",
  "deliveries.loading_detail": "\u52A0\u8F7D\u8BE6\u60C5...",
  "deliveries.col_title": "\u6807\u9898",
  "deliveries.col_type": "\u7C7B\u578B",
  "deliveries.col_user": "\u7528\u6237",
  "deliveries.col_conversation": "\u4F1A\u8BDD",
  "deliveries.col_pinned": "\u7F6E\u9876",
  "deliveries.col_hidden": "\u9690\u85CF",
  "deliveries.col_deleted": "\u5DF2\u5220\u9664",
  "deliveries.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "deliveries.detail_user": "\u7528\u6237",
  "deliveries.detail_conversation": "\u4F1A\u8BDD",
  "deliveries.detail_mime": "MIME",
  "deliveries.detail_size": "\u5927\u5C0F",
  "deliveries.detail_updated": "\u66F4\u65B0\u65F6\u95F4",
  "deliveries.reindex": "\u91CD\u5EFA\u7D22\u5F15",
  "deliveries.unhide": "\u53D6\u6D88\u9690\u85CF",
  "deliveries.unpin": "\u53D6\u6D88\u7F6E\u9876",
  "deliveries.reindex_title": "\u91CD\u5EFA\u4EA4\u4ED8\u7269\u7D22\u5F15",
  "deliveries.unhide_title": "\u53D6\u6D88\u9690\u85CF\u4EA4\u4ED8\u7269",
  "deliveries.unpin_title": "\u53D6\u6D88\u7F6E\u9876\u4EA4\u4ED8\u7269",
  "deliveries.reindex_desc":
    "\u8FD9\u5C06\u89E6\u53D1\u4EA4\u4ED8\u5185\u5BB9\u7684\u91CD\u65B0\u7D22\u5F15\u3002",
  "deliveries.unhide_desc":
    "\u8FD9\u5C06\u4F7F\u4EA4\u4ED8\u7269\u5BF9\u7528\u6237\u91CD\u65B0\u53EF\u89C1\u3002",
  "deliveries.unpin_desc":
    "\u8FD9\u5C06\u79FB\u9664\u4EA4\u4ED8\u7269\u7684\u7F6E\u9876\u3002",

  // ─── Integrations Page ───
  "integrations.title": "\u96C6\u6210",
  "integrations.description": "SDK\u3001\u63D2\u4EF6\u548C CLI \u6307\u6807",
  "integrations.tab_sdk": "SDK",
  "integrations.tab_openclaw": "OpenClaw",
  "integrations.tab_claude_code": "Claude Code \u63D2\u4EF6",
  "integrations.tab_codex": "Codex \u63D2\u4EF6",
  "integrations.tab_cli": "CLI",
  "integrations.active_accounts": "\u6D3B\u8DC3\u8D26\u53F7",
  "integrations.active_agents": "\u6D3B\u8DC3 Agent",
  "integrations.messages": "\u6D88\u606F",
  "integrations.deliveries": "\u4EA4\u4ED8\u7269",
  "integrations.errors": "\u9519\u8BEF",
  "integrations.disconnects": "\u65AD\u5F00\u8FDE\u63A5",
  "integrations.version_distribution": "\u7248\u672C\u5206\u5E03",
  "integrations.col_version": "\u7248\u672C",
  "integrations.col_count": "\u6570\u91CF",
  "integrations.col_share": "\u5360\u6BD4",
  "integrations.no_version_data": "\u65E0\u7248\u672C\u6570\u636E",

  // ─── Health Page ───
  "health.title": "\u7CFB\u7EDF\u5065\u5EB7",
  "health.description":
    "\u7EC4\u4EF6\u72B6\u6001\u4E0E\u540E\u53F0\u4EFB\u52A1\u76D1\u63A7",
  "health.components": "\u7EC4\u4EF6",
  "health.api": "API",
  "health.neon": "Neon (\u6570\u636E\u5E93)",
  "health.kv": "KV \u5B58\u50A8",
  "health.r2": "R2 \u5B58\u50A8",
  "health.checked_at": "\u68C0\u67E5\u65F6\u95F4",
  "health.queue_stats": "\u961F\u5217\u7EDF\u8BA1",
  "health.poison_messages": "\u6BD2\u6D88\u606F",
  "health.pending_jobs": "\u7B49\u5F85\u4EFB\u52A1",
  "health.running_jobs": "\u8FD0\u884C\u4EFB\u52A1",
  "health.failed_24h": "\u5931\u8D25 (24h)",
  "health.cron_tasks": "\u5B9A\u65F6\u4EFB\u52A1",
  "health.col_name": "\u540D\u79F0",
  "health.col_status": "\u72B6\u6001",
  "health.col_detail": "\u8BE6\u60C5",

  // ─── Crashes ───
  "crashes.title": "\u5D29\u6E83\u62A5\u544A",
  "crashes.description":
    "\u81EA\u6258\u7BA1 /v1/crash \u7AEF\u70B9\u4E0A\u62A5\u7684\u5206\u7EC4\u5D29\u6E83\u8BB0\u5F55",
  "crashes.filter_platform": "\u5E73\u53F0",
  "crashes.filter_since": "\u65F6\u95F4\u8303\u56F4",
  "crashes.filter_all": "\u5168\u90E8",
  "crashes.since_24h": "24 \u5C0F\u65F6",
  "crashes.since_7d": "7 \u5929",
  "crashes.since_30d": "30 \u5929",
  "crashes.no_groups":
    "\u5F53\u524D\u7A97\u53E3\u65E0\u5D29\u6E83\u8BB0\u5F55\u3002",
  "crashes.col_error": "\u9519\u8BEF",
  "crashes.col_platform": "\u5E73\u53F0",
  "crashes.col_count": "\u6B21\u6570",
  "crashes.col_first_seen": "\u9996\u6B21\u89C1\u5230",
  "crashes.col_last_seen": "\u6700\u8FD1\u89C1\u5230",
  "crashes.samples_title": "\u6700\u8FD1\u6837\u672C",
  "crashes.back_to_list": "\u8FD4\u56DE\u5217\u8868",
  "crashes.sample_stack": "\u5806\u6808",
  "crashes.sample_breadcrumbs": "\u9762\u5305\u5C51",
  "crashes.sample_extra": "\u9644\u52A0\u4E0A\u4E0B\u6587",
  "crashes.sample_app_version": "\u5E94\u7528\u7248\u672C",
  "crashes.sample_os_version": "\u7CFB\u7EDF\u7248\u672C",
  "crashes.sample_is_fatal": "\u81F4\u547D",
  "crashes.sample_component_stack": "\u7EC4\u4EF6\u6808",
  "crashes.sample_device_hash": "\u8BBE\u5907\u6807\u8BC6",
  "crashes.sample_user_hash": "\u7528\u6237\u6807\u8BC6",
  "crashes.sample_client_time": "\u5BA2\u6237\u7AEF\u65F6\u95F4",
  "crashes.group_count": "{{count}} \u6B21\u53D1\u751F",

  // ─── Relations ───
  "relations.title": "\u5173\u7CFB",
  "relations.description":
    "\u67E5\u770B\u548C\u5BA1\u8BA1\u7528\u6237\u5173\u7CFB",
  "relations.col_type": "\u7C7B\u578B",
  "relations.col_user_a": "\u7528\u6237 A",
  "relations.col_user_b": "\u7528\u6237 B / Agent",
  "relations.col_status": "\u72B6\u6001",
  "relations.col_conversation": "\u4F1A\u8BDD",
  "relations.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "relations.all_types": "\u6240\u6709\u7C7B\u578B",
  "relations.all_status": "\u6240\u6709\u72B6\u6001",
  "relations.search_placeholder":
    "\u6309\u540D\u79F0\u6216\u90AE\u7BB1\u641C\u7D22...",
  "relations.no_relations": "\u672A\u627E\u5230\u5173\u7CFB\u8BB0\u5F55\u3002",
  "relations.page_info":
    "{{total}} \u6761\u5173\u7CFB \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Blocks ───
  "blocks.title": "\u5C4F\u853D",
  "blocks.description":
    "\u67E5\u770B\u5C4F\u853D\u8BB0\u5F55\u4EE5\u8C03\u67E5\u6EE5\u7528",
  "blocks.col_blocker": "\u5C4F\u853D\u8005",
  "blocks.col_blocked": "\u88AB\u5C4F\u853D\u8005",
  "blocks.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "blocks.blocker_placeholder": "\u5C4F\u853D\u8005 UUID...",
  "blocks.blocked_placeholder": "\u88AB\u5C4F\u853D\u8005 UUID...",
  "blocks.no_blocks": "\u672A\u627E\u5230\u5C4F\u853D\u8BB0\u5F55\u3002",
  "blocks.page_info":
    "{{total}} \u6761\u5C4F\u853D \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Conversations ───
  "conversations.title": "\u4F1A\u8BDD",
  "conversations.description":
    "\u8BCA\u65AD\u4F1A\u8BDD\u72B6\u6001\u548C\u6210\u5458",
  "conversations.col_id": "ID",
  "conversations.col_type": "\u7C7B\u578B",
  "conversations.col_members": "\u6210\u5458",
  "conversations.col_last_activity": "\u6700\u540E\u6D3B\u52A8",
  "conversations.col_frozen": "\u51BB\u7ED3",
  "conversations.col_terminated": "\u7EC8\u6B62",
  "conversations.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "conversations.all_types": "\u6240\u6709\u7C7B\u578B",
  "conversations.all_frozen": "\u5168\u90E8",
  "conversations.frozen_yes": "\u5DF2\u51BB\u7ED3",
  "conversations.frozen_no": "\u672A\u51BB\u7ED3",
  "conversations.all_terminated": "\u5168\u90E8",
  "conversations.terminated_yes": "\u5DF2\u7EC8\u6B62",
  "conversations.terminated_no": "\u672A\u7EC8\u6B62",
  "conversations.search_placeholder": "\u4F1A\u8BDD ID...",
  "conversations.no_conversations": "\u672A\u627E\u5230\u4F1A\u8BDD\u3002",
  "conversations.page_info":
    "{{total}} \u4E2A\u4F1A\u8BDD \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Conversation Detail ───
  "conv_detail.title": "\u4F1A\u8BDD\u8BE6\u60C5",
  "conv_detail.info": "\u4FE1\u606F",
  "conv_detail.members": "\u6210\u5458",
  "conv_detail.message_stats": "\u6D88\u606F\u7EDF\u8BA1",
  "conv_detail.col_member": "\u6210\u5458",
  "conv_detail.col_type": "\u7C7B\u578B",
  "conv_detail.col_unread": "\u672A\u8BFB",
  "conv_detail.col_muted": "\u9759\u97F3",
  "conv_detail.col_pinned": "\u7F6E\u9876",
  "conv_detail.col_hidden": "\u9690\u85CF",
  "conv_detail.col_joined": "\u52A0\u5165\u65F6\u95F4",
  "conv_detail.total_messages": "\u6D88\u606F\u603B\u6570",
  "conv_detail.recalled": "\u5DF2\u64A4\u56DE",
  "conv_detail.by_type": "\u6309\u5185\u5BB9\u7C7B\u578B",
  "conv_detail.by_sender": "\u6309\u53D1\u9001\u8005\u7C7B\u578B",
  "conv_detail.not_found": "\u672A\u627E\u5230\u4F1A\u8BDD\u3002",

  // ─── Messages Tab ───
  "messages_tab.title": "\u6D88\u606F",
  "messages_tab.total_messages": "\u6D88\u606F\u603B\u6570",
  "messages_tab.human_ratio": "\u4EBA\u7C7B\u5360\u6BD4",
  "messages_tab.agent_ratio": "Agent \u5360\u6BD4",
  "messages_tab.recall_rate": "\u64A4\u56DE\u7387",
  "messages_tab.daily_trends": "\u6BCF\u65E5\u6D88\u606F\u8D8B\u52BF",
  "messages_tab.type_distribution": "\u5185\u5BB9\u7C7B\u578B\u5206\u5E03",
  "messages_tab.col_date": "\u65E5\u671F",
  "messages_tab.col_human": "\u4EBA\u7C7B",
  "messages_tab.col_agent": "Agent",
  "messages_tab.col_system": "\u7CFB\u7EDF",
  "messages_tab.col_total": "\u603B\u8BA1",
  "messages_tab.col_content_type": "\u5185\u5BB9\u7C7B\u578B",
  "messages_tab.col_count": "\u6570\u91CF",
  "messages_tab.col_percentage": "\u5360\u6BD4",

  // ─── Sidebar: Invites ───
  "nav.invites": "\u9080\u8BF7",
  "nav.invites.applications": "\u7533\u8BF7\u5217\u8868",
  "nav.invites.codes": "\u9080\u8BF7\u7801",

  // ─── Applications ───
  "applications.title": "\u7533\u8BF7\u5217\u8868",
  "applications.description":
    "\u7BA1\u7406\u9080\u8BF7\u5236\u6CE8\u518C\u7533\u8BF7",
  "applications.tab_all": "\u5168\u90E8",
  "applications.tab_pending": "\u5F85\u5BA1\u6838",
  "applications.tab_approved": "\u5DF2\u901A\u8FC7",
  "applications.tab_rejected": "\u5DF2\u62D2\u7EDD",
  "applications.col_email": "\u90AE\u7BB1",
  "applications.col_name": "\u59D3\u540D",
  "applications.col_role": "\u89D2\u8272",
  "applications.col_reason": "\u7533\u8BF7\u7406\u7531",
  "applications.col_status": "\u72B6\u6001",
  "applications.col_date": "\u65E5\u671F",
  "applications.col_actions": "\u64CD\u4F5C",
  "applications.approve": "\u901A\u8FC7",
  "applications.reject": "\u62D2\u7EDD",
  "applications.reject_title": "\u62D2\u7EDD\u7533\u8BF7",
  "applications.reject_desc":
    "\u8BF7\u63D0\u4F9B\u62D2\u7EDD\u8BE5\u7533\u8BF7\u7684\u7406\u7531\u3002",
  "applications.no_applications":
    "\u672A\u627E\u5230\u7533\u8BF7\u8BB0\u5F55\u3002",
  "applications.page_info":
    "\u5171 {{total}} \u6761\u7533\u8BF7 \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Invite Codes ───
  "invite_codes.title": "\u9080\u8BF7\u7801",
  "invite_codes.description": "\u7BA1\u7406\u6CE8\u518C\u9080\u8BF7\u7801",
  "invite_codes.create_code": "\u521B\u5EFA\u9080\u8BF7\u7801",
  "invite_codes.all_status": "\u5168\u90E8\u72B6\u6001",
  "invite_codes.status_available": "\u53EF\u7528",
  "invite_codes.status_claimed": "\u5DF2\u4F7F\u7528",
  "invite_codes.status_expired": "\u5DF2\u8FC7\u671F",
  "invite_codes.col_code": "\u9080\u8BF7\u7801",
  "invite_codes.col_issued_by": "\u7B7E\u53D1\u4EBA",
  "invite_codes.col_claimed_by": "\u4F7F\u7528\u4EBA",
  "invite_codes.col_status": "\u72B6\u6001",
  "invite_codes.col_created": "\u521B\u5EFA\u65F6\u95F4",
  "invite_codes.col_expires": "\u8FC7\u671F\u65F6\u95F4",
  "invite_codes.never": "\u6C38\u4E0D\u8FC7\u671F",
  "invite_codes.no_codes": "\u672A\u627E\u5230\u9080\u8BF7\u7801\u3002",
  "invite_codes.page_info":
    "\u5171 {{total}} \u4E2A\u9080\u8BF7\u7801 \u00B7 \u7B2C {{page}} \u9875\uFF0C\u5171 {{totalPages}} \u9875",

  // ─── Date Picker ───
  "date_picker.date": "\u65E5\u671F",
  "date_picker.7d": "7 \u5929",
  "date_picker.30d": "30 \u5929",
  "date_picker.90d": "90 \u5929",
  "date_picker.1y": "1 \u5E74",
  "date_picker.custom": "\u81EA\u5B9A\u4E49",
};
